
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/datenschutz",
      function () {
        return require("private-next-pages/[lang]/datenschutz.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/datenschutz"])
      });
    }
  